document.addEventListener('DOMContentLoaded', function() {
  function getScrollPosition() {
    return this.scrollY;
  }

  let scrollPosition = 0;
  const search = document.querySelector('.site-header__search-toggle');
  const searchClose = document.querySelector('.search-modal__close');
  const body = document.querySelector('body');
  const searchInModal1 =  document.getElementById("Search-In-Modal-1");
  const headerSearch = document.querySelector('.header-search');

  search.addEventListener('click', function(e) {
    if (!body.classList.contains('mobile-nav__open')) {
      scrollPosition = getScrollPosition();
      const isFirefox = typeof InstallTrigger !== 'undefined';
      if(!isFirefox) {
        body.style.top = `-${scrollPosition}px`;
      } else {
        const announcementBarHeight =  document.querySelector('#js-announcement-bar').offsetHeight;
        if(scrollPosition > announcementBarHeight) {
          body.style.top = `-${announcementBarHeight}px`;
        } else {
          body.style.top = 0;
        }
      }
    } else {
      headerSearch.setAttribute('data-control-search', true );
    }
    headerSearch.classList.add('open');
    searchInModal1.click();
    searchInModal1.focus();
    body.classList.add('search-modal__open');
    e.stopImmediatePropagation();
  });

  window.addEventListener('click', function(e) {
    if(!e.target.matches('#Search-In-Modal-1.search__input, .header-search.open, .predictive-search.predictive-search--header, predictive-search__list-item, .predictive-search__item')) {
      if(headerSearch.classList.contains('open')) {
        closeModal();
      };
    };
  });

  if (searchClose) {
    searchClose.addEventListener('click', function() {
      closeModal();
    });
  }

  function closeModal() {
    searchInModal1.value = '';
    headerSearch.classList.remove('open');
    if (!headerSearch.getAttribute('data-control-search')) {
      body.classList.remove('search-modal__open');
      window.scrollTo({ top: scrollPosition });
    } else {
      headerSearch.removeAttribute('data-control-search');
    }
    body.setAttribute('style', '');
  };
})


function debounce(func, wait) {
  var timeout = null;
  return function() {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      func.apply(context, args);
    }, wait || 0);
  };
}

kinetic.header = (() => {
  const classes = {
    isOpen: 'isOpen'
  }
  const mediumUpQuery = '(min-width: 990px)';
  let mql = window.matchMedia(mediumUpQuery);

  let cache = {};

  const init = () => {
    cacheSelectors();

    cache.siteNavCTA.forEach(element => {
      element.addEventListener('mouseover', () => {
        openSiteNav(element.parentElement);
      });
    });

    try {
      mql.addEventListener('change', initBreakpoints);
    } catch (e) {
      console.error(e);
    }

    window.addEventListener('keyup', (e) => { keyUpHandler(e) });
    window.addEventListener('click', (e) => { keyUpHandler(e) });

    window.addEventListener('resize',
      debounce(function() {
        kinetic.header.hackSubMenuPageViewWidth();
    }, 50));

    hackSubMenuPageViewWidth();
  }

  const hackSubMenuPageViewWidth = () => {
    let headerWidth = document.getElementById('site-header').offsetWidth;
    let bodyWidth = document.body.offsetWidth;
    let menus = document.getElementById('siteNav').children;

    if(menus){
      let subMenu;
      for(let menu in menus) {
        if(menus[menu].hasChildNodes) {
          subMenu = menus[menu].getElementsByTagName('ul')[0];
          if(subMenu){
            subMenu.style.width = "100vw";
            let scrollbarWidth = window.innerWidth - document.body.clientWidth;
            scrollbarWidth = `calc(100vw - ${scrollbarWidth}px)`;
            subMenu.style.setProperty('width', scrollbarWidth);
            subMenu.style.left = -((bodyWidth-headerWidth)/2) + "px";
            subMenu.style.paddingLeft = (((bodyWidth-headerWidth)/2)+55) + "px";
            subMenu.style.paddingRight = (((bodyWidth-headerWidth)/2)+55) + "px";

            let megaImages = document.getElementById('site-header').querySelectorAll('.megaImages');
            megaImages.forEach(megaImage => {
              if(bodyWidth > headerWidth){
                megaImage.style.right = (((bodyWidth-headerWidth)/2)+55) + "px";
                megaImage.style.maxWidth = "1000px";
              }else{
                megaImage.style.maxWidth = "75%";
              }
            })
          }
        }
      }
    }
  }

  const initBreakpoints = () => {
    if (
      mql.matches &&
      cache.siteNav.classList.contains(classes.isOpen)
    ) {
      openSiteNav();
    }
  }

  const openSiteNav = (navElement) => {
    let openElemSiblings = getSiblings(navElement);
    openElemSiblings.forEach(openElemSibling => openElemSibling.classList.remove(classes.isOpen));
    navElement.classList.add(classes.isOpen);
    navElement.setAttribute('aria-expanded', true);
    closeNavOnMouseLeave(navElement);
  }

  const closeSiteNav = (navElement) => {
    navElement.classList.remove(classes.isOpen);
    navElement.setAttribute('aria-expanded', false);
    navElement.focus();
  }

  const keyUpHandler = (e) => {
    if (e.which === 27 || !cache.siteNav.contains(e.target)) {
      const isOpen = cache.siteNav.querySelector('.isOpen');
      isOpen && closeSiteNav(isOpen);
    }
  }

  const closeNavOnMouseLeave = (navElement) => {
    const nav = navElement.querySelector('ul');
    nav && nav.addEventListener('mouseleave', () => {
      closeSiteNav(navElement);
    });
  };

  const getSiblings = (elem) => {
    return Array.from(elem.parentNode.children).filter(child => child !== elem);
  };

  const cacheSelectors = () => {
    cache = {
      siteNav: document.getElementById('siteNav'),
      siteNavCTA: document.getElementById('siteNav').querySelectorAll('button, a'),
      sectionHeader: document.getElementById('shopify-section-header')
    }
  }

  return {
    init: init,
    hackSubMenuPageViewWidth: hackSubMenuPageViewWidth
  };
})();

kinetic.header.init();

(function() {
  document.querySelector('.site-header__account').addEventListener('mouseover', () => {
    const currencyWrapper = document.querySelector('.currency-items');
    if (currencyWrapper?.classList.contains('open')) {
      currencyWrapper.classList.remove('open');
    }
  })
})();
